<template>
  <div class="sidebar">
    <h2 class="elements-label">Compositions</h2>
    <!-- <div v-if="currentPage" v-for="(e, index) in currentPage.getPropertiesDescription()" :key="e.name" class="array-item">
      <component :is="e.jsType" :element="currentPage[e.name]" :container="currentPage" :property="e"/>
    </div> -->
    <div v-if="compositionEditing" v-for="(e, index) in compositionEditing.changeableProperty" :key="e.name" class="array-item">
      <component :labeled="false" :is="e.type" :element="getFromName(e.name)" :container="getFromName(e.name, true)" :property="e"/>
    </div>

    <!-- Bouton d'ajout d'élément -->
    <button class="add-element-button" @click="showAddElementPopup = true">
      <addIcon/>
      Ajouter un bloc
    </button>

    <!-- Popup d'ajout d'élément -->
    <AddElementPopup
      :show="showAddElementPopup"
      :elements="compositionElements"
      title="Ajouter un plan"
      @close="showAddElementPopup = false"
      @select="addElement"
    />

  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import * as namespaceStore from "../../vuexStore/namespaceStore.js"
import * as actions from "../../vuexStore/actions.js"
import SelectInput from "../PropertyComponents/select.vue"
import BooleanInput from "../PropertyComponents/boolean.vue"
import NumberInput from "../PropertyComponents/number.vue"
import ObjectSidebar from "./SidebarComponents/object.vue"
import ArraySidebar from "./SidebarComponents/array.vue"
import addIcon from "../IconComponents/addIcon.vue"
import textInput from "../PropertyComponents/text.vue"
import AddElementPopup from "../PopupComponents/AddElementPopup.vue"
import compositionElement from "../../vuexStore/type/definition/compositionElement.js"

export default {
  name: 'Sidebar',
  props: {
  },
  emits: [
  ],
  components: {
    selectInput: SelectInput,
    booleanInput: BooleanInput,
    numberInput: NumberInput,
    objectInput: ObjectSidebar,
    arrayInput: ArraySidebar,
    textInput: textInput,
    addIcon,
    AddElementPopup
  },
  data() {
    return {
      showAddElementPopup: false
    }
  },
  computed: {
    ...mapGetters(namespaceStore.THEME, [
        'compositionEditing',
    ]),
    compositionElements() {
      return compositionElement.filter(el => el.type.match("^.*FilterItem$") == null);
    }
  },
  methods: {
    ...mapActions(namespaceStore.THEME, {
      'addCompositionElement': actions.ADD_COMPOSITION_ELEMENT
    }),
    getFromName(name, container = false) {
      let nameLink = name.split(".");
      let result = this.compositionEditing;
      nameLink.forEach((el, index) => {
        if (container == true) {
          if (index < nameLink.length - 1)
            result = result[el];
        }
        else {
          result = result[el];
        }
      });
      return result;
    },
    addElement(element) {
      this.addCompositionElement(element.constructor.fromObject({parent: this.compositionEditing.Build}));
      this.showAddElementPopup = false;
    },
  }
}
</script>

<style scoped>
.sidebar {
  padding: 1rem;
}

.elements-label {
  color: #fff;
  font-size: 1.25rem;
  font-weight: 500;
  margin-bottom: 1rem;
  padding-bottom: 0.5rem;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  text-align: center;
}

.add-element-button {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  width: 100%;
  padding: 0.75rem;
  background-color: rgba(59, 130, 246, 0.2);
  border: 1px solid rgba(59, 130, 246, 0.3);
  border-radius: 0.375rem;
  color: #fff;
  font-weight: 500;
  transition: all 0.2s ease;
  margin-bottom: 1rem;
}

.add-element-button:hover {
  background-color: rgba(59, 130, 246, 0.3);
  border-color: #3b82f6;
}

.add-element-button:focus {
  outline: none;
  box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.4);
}

.close-button {
  font-family: Avenir;
}
</style> 